/**
 * Styles
 */
import './Resources/Private/Styles/app.scss';

/**
 * Scripts
 */
import 'bootstrap';
import './Resources/Private/JavaScript/main';
import './Resources/Private/JavaScript/nav';
import './Resources/Private/JavaScript/components/*';
